import React from 'react';

interface ProductDetailsModalProps {
  productDetails: any; // TODO: Определить более точный  тип
  onClose: () => void;
}

const ProductDetailsModal: React.FC<ProductDetailsModalProps> = ({ productDetails, onClose }) => {

  if (!productDetails) {
    return null;
  }

  // Исключаемые поля
  const excludedFields = [
    'ETIM_CLASS',
    'ETIM_CLASS_NAME',
    'ETIM_GROUP',
    'ETIM_GROUP_NAME',
    'VIDEO',
    'BARCODE',
    'RELATED_ITEMS',
    'SIMILAR_ITEMS',
  ];

  // Фильтрация характеристик
  const filteredSpecs = productDetails.SPECS?.filter(
    (spec: any) => !excludedFields.includes(spec.FEATURE_CODE)
  );

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
{/* Кнопка закрытия */}
          <button
            className="absolute top-3 right-3 bg-gray-200 hover:bg-gray-300 rounded-full p-1 focus:outline-none"
            onClick={onClose}
          >
            {/* Иконка крестика */}
            <svg className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        <div className="mt-3 text-center">
          {/* Заголовок модального окна */}
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {productDetails.INFO?.[0]?.DESCRIPTION || 'Детали продукта'}
          </h3>
          <div className="mt-2 px-7 py-3 text-left">
            <div className="flex flex-wrap md:flex-nowrap -mx-2"> {/* Use flex-wrap for responsiveness and negative margin for gap */}
              {/* Изображение */}
              {productDetails.IMG?.length > 0 && (
                <div className="w-full md:w-1/2 lg:w-1/3 px-2"> {/* Adjust width for responsiveness */}
                  <div className="main-image-container h-96 flex items-center justify-center"> {/* Добавлен контейнер для стилизации */}
                    <img src={productDetails.IMG[0].URL} alt={`Product Image 1`} className="max-h-96 object-contain mx-auto" /> {/* Увеличена максимальная высота */}
                  </div>
                </div>
              )}

              {/* Общая информация */}
              {productDetails.INFO?.[0] && (
                <div className="w-full md:w-1/2 lg:w-2/3 px-2 mt-4 md:mt-0"> {/* Adjust width for responsiveness */}
                  <h4 className="text-gray-600 font-normal mb-2">Общая информация:</h4>
                  <ul className="text-sm text-gray-700">
                    {productDetails.INFO[0].BRAND && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Производитель:</span> {productDetails.INFO[0].BRAND}</li>}
                    {productDetails.INFO[0].SERIES && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Серия:</span> {productDetails.INFO[0].SERIES}</li>}
                    {productDetails.INFO[0].VENDOR_CODE && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Артикул поставщика:</span> {productDetails.INFO[0].VENDOR_CODE}</li>}
                    {productDetails.INFO[0].PRIMARY_UOM && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Единица измерения:</span> {productDetails.INFO[0].PRIMARY_UOM}</li>}
                    {productDetails.INFO[0].MULTIPLICITY && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Кратность:</span> {productDetails.INFO[0].MULTIPLICITY}</li>}
                    {productDetails.INFO[0].ORIGIN_COUNTRY && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Страна происхождения:</span> {productDetails.INFO[0].ORIGIN_COUNTRY}</li>}
                    {productDetails.INFO[0].WARRANTY && <li className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Гарантия:</span> {productDetails.INFO[0].WARRANTY}</li>}
                  </ul>
                </div>
              )}
            </div>

            {/* Характеристики */}
            {filteredSpecs && filteredSpecs.length > 0 && (
              <div className="mb-4">
                <h4 className="text-gray-600 font-normal mb-2">Характеристики:</h4>
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 text-sm text-gray-700"> {/* Grid layout */}
                  {filteredSpecs.map((spec: any, index: number) => (
                    <div key={index} className="border-b border-gray-200 pb-1 mb-1"> {/* Grid item */}
                      <span className="font-bold">{spec.NAME}:</span> {spec.VALUE} {spec.UOM}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Логистические детали */}
            {productDetails.INFO?.[0]?.LOGISTIC_DETAILS && (
              <div className="mb-4">
                <h4 className="text-gray-600 font-normal mb-2">Логистические детали:</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 text-sm text-gray-700"> {/* Grid layout */}
                  {productDetails.INFO?.[0]?.LOGISTIC_DETAILS?.[0]?.WIDTH && <div className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Ширина:</span> {productDetails.INFO[0].LOGISTIC_DETAILS[0].WIDTH} {productDetails.INFO[0].LOGISTIC_DETAILS[0].DIMENSION_UOM}</div>}
                  {productDetails.INFO?.[0]?.LOGISTIC_DETAILS?.[0]?.HEIGHT && <div className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Высота:</span> {productDetails.INFO[0].LOGISTIC_DETAILS[0].HEIGHT} {productDetails.INFO[0].LOGISTIC_DETAILS[0].DIMENSION_UOM}</div>}
                  {productDetails.INFO?.[0]?.LOGISTIC_DETAILS?.[0]?.LENGTH && <div className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Длина:</span> {productDetails.INFO[0].LOGISTIC_DETAILS[0].LENGTH} {productDetails.INFO[0].LOGISTIC_DETAILS[0].DIMENSION_UOM}</div>}
                  {productDetails.INFO?.[0]?.LOGISTIC_DETAILS?.[0]?.WEIGHT && <div className="border-b border-gray-200 pb-1 mb-1"><span className="font-bold">Вес:</span> {productDetails.INFO[0].LOGISTIC_DETAILS[0].WEIGHT} {productDetails.INFO[0].LOGISTIC_DETAILS[0].WEIGHT_UOM}</div>}
                </div>
              </div>
            )}

            {/* Длинное описание */}
            {productDetails.INFO?.[0]?.LONG_DESCRIPTION && (
              <div>
                <h4 className="text-gray-600 font-normal mb-2">Описание:</h4>
                <p className="text-sm text-gray-700 whitespace-pre-line">
                  {productDetails.INFO[0].LONG_DESCRIPTION}
                </p>
              </div>
            )}

            {/* Документы */}
            {(productDetails.CERTIFICATE?.length > 0 || productDetails.CATALOG_BROCHURE?.length > 0 || productDetails.PASSPORT?.length > 0) && (
              <div className="mb-4 mt-4">
                <h4 className="text-gray-600 font-normal mb-2">Документы:</h4>
                {productDetails.CERTIFICATE?.length > 0 && (
                  <div className="mb-2">
                    <h5 className="text-gray-600 font-normal mb-1">Сертификаты:</h5>
                    <ul className="list-disc list-inside text-sm text-gray-700">
                      {productDetails.CERTIFICATE.map((cert: any, index: number) => (
                        <li key={`cert-${index}`} className="border-b border-gray-200 pb-1 mb-1">
                          <a href={cert.URL} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            {cert.CERT_NUM || "Сертификат " + (index + 1)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {productDetails.CATALOG_BROCHURE?.length > 0 && (
                  <div className="mb-2">
                    <h5 className="text-gray-600 font-normal mb-1">Каталоги/Брошюры:</h5>
                    <ul className="list-disc list-inside text-sm text-gray-700">
                      {productDetails.CATALOG_BROCHURE.map((cat: any, index: number) => (
                       <li key={`cat-${index}`} className="border-b border-gray-200 pb-1 mb-1">
                         <a href={cat.URL} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                           Каталог {index + 1}
                         </a>
                       </li>
                     ))}
                    </ul>
                  </div>
                )}
                {productDetails.PASSPORT?.length > 0 && (
                  <div>
                    <h5 className="text-gray-600 font-normal mb-1">Паспорта:</h5>
                    <ul className="list-disc list-inside text-sm text-gray-700">
                      {productDetails.PASSPORT.map((pass: any, index: number) => (
                        <li key={`pass-${index}`} className="border-b border-gray-200 pb-1 mb-1">
                          <a href={pass.URL} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            Паспорт {index + 1}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsModal;